<div class="notes-tab">
  <div class="add-note">
    <mat-form-field appearance="outline" class="full">
      <mat-label>Add a note</mat-label>
      <textarea matInput [(ngModel)]="newNoteContent" [maxlength]="maxCharacters" rows="3"></textarea>
      <mat-hint align="end">{{ getRemainingCharacters() }} characters left</mat-hint>
    </mat-form-field>
    <button mat-raised-button color="primary" [disabled]="!canPublish()" (click)="publishNote()">
      <mat-icon>add_comment</mat-icon> Publish
    </button>
  </div>

  <div *ngIf="loadError" class="error">{{ loadError }}</div>

  <div *ngIf="!loadError && notes.length === 0" class="empty">No notes yet.</div>

  <div class="note" *ngFor="let n of notes">
    <div class="note-content">{{ n.content }}</div>
    <div class="note-meta">{{ n.createdByName || n.createdBy || 'System' }}<ng-container *ngIf="n.source"> · {{ n.source }}</ng-container> · {{ n.createdAt | date:'MM/dd/yyyy h:mm a' }}</div>
  </div>
</div>
